import PageBody from './page-body';

export default PageBody;
